<template>
  {{ $t("ticket.creationRequest.title", [incident.type]) }}

  {{ $t("ticket.creationRequest.body") }}

  <button @click="handleCancelClick" :disabled="isDisabled">
    {{ $t("ticket.creationRequest.no") }}
  </button>

  <button @click="handleApproveClick" :disabled="isDisabled">
    {{ $t("ticket.creationRequest.yes") }}
  </button>
</template>

<script lang="ts">
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { IncidentDTO } from "@moderrotech/servers-communication-library/src/types";

export default {
  setup() {
    const store = useStore();

    const incident = computed((): IncidentDTO => store.state.incident.incident);

    const isDisabled = ref(false);

    return {
      incident,
      isDisabled,
      handleCancelClick: () => {
        isDisabled.value = true;
        store.dispatch("incident/close", {
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      },
      handleApproveClick: () => {
        isDisabled.value = true;
        store.dispatch("incident/startProcessing", {
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      }
    };
  }
};
</script>
<style lang="scss"></style>
